/**
 * CetusEd Community Portal — Application Entry Point
 *
 * COMPLIANCE: FERPA §1232g(b) requires authentication before any PII access.
 *   The community portal enforces auth at the router level via ProtectedRoute.
 *   This entry renders the App component with QueryClientProvider for
 *   server data fetching and BrowserRouter for client-side routing.
 *
 * MIGRATION TARGET: This is a new application in the NextGen architecture.
 *   The monolith has no parent/guardian portal.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AppError } from '@cetused/shared';
import { App } from './App';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 2,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw AppError.internal('Root element #root not found in the DOM');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
